import { render } from "./approvDelete.vue?vue&type=template&id=18291916&scoped=true"
import script from "./approvDelete.vue?vue&type=script&lang=js"
export * from "./approvDelete.vue?vue&type=script&lang=js"

import "./approvDelete.vue?vue&type=style&index=0&id=18291916&lang=scss&scoped=true"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18291916"]])

export default __exports__